document.addEventListener('DOMContentLoaded', () => {
  const bubbles = document.querySelectorAll('.tco-has-bubble');

  if( bubbles ) {
    bubbles.forEach((bubble) => {
      const beforeSibling = bubble.previousElementSibling;

      if( beforeSibling ) {
        beforeSibling.classList.add('tco-bubble-buster');
      }
    });
  }



})